module.exports = __webpack_public_path__ + "img/rolling10_icon.5ab59c91.png";